var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconServe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.17 55.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#db3326;fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_serve") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.26,46.36V42.68a.88.88,0,0,0-.89-.89H49.68V34.36A4.07,4.07,0,0,0,48.94,32h4.45a2.79,2.79,0,0,0,0-5.59H51.65A23.9,23.9,0,0,0,31.28,6.58a4.07,4.07,0,1,0-6.37,0A23.88,23.88,0,0,0,4.53,26.41H2.79a2.79,2.79,0,0,0,0,5.59H6.15c.21,1.14,1.07,3,4.19,4.38,3.5,1.53,18.53,3.43,24.22,4.11v1.31H33.29a.88.88,0,0,0-.89.89v3.69a2.78,2.78,0,0,0-2.65,2.79v4A2.77,2.77,0,0,0,32.54,56H53.12a2.77,2.77,0,0,0,2.79-2.79v-4A2.77,2.77,0,0,0,53.26,46.36ZM28.08,1.76a2.31,2.31,0,1,1-2.29,2.31A2.32,2.32,0,0,1,28.08,1.76Zm0,6.37A22.14,22.14,0,0,1,49.87,26.41H6.3A22.14,22.14,0,0,1,28.08,8.13ZM7,30.24H2.79a1,1,0,0,1,0-2.07h50.6a1,1,0,0,1,0,2.07H7ZM11,34.75C8.92,33.84,8.2,32.71,8,32h37.6a2.36,2.36,0,0,1,2.36,2.36v7.43H36.32V39.71a.87.87,0,0,0-.77-.87C25.5,37.65,13.79,36,11,34.75Zm43.1,18.42a1,1,0,0,1-1,1H32.54a1,1,0,0,1-1-1v-4a1,1,0,0,1,1-1h5a.89.89,0,0,0,0-1.77H34.16v-2.8H51.5v2.8H40.31a.89.89,0,0,0,0,1.77h12.8a1,1,0,0,1,1,1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServe);
export default __webpack_public_path__ + "static/media/icon_serve.1e7f7a807a079b74dca115f470ab081c.svg";
export { ForwardRef as ReactComponent };